import { Container, Hr } from '@react-email/components';
import { merge } from 'lodash';

const divider = {
    EditorElement: props => {
        const { attributes, children, element } = props;
        const containerStyle = {
            style: {
                maxWidth: '100%',
            },
        };
        return (
            <Container
                contentEditable={false}
                {...attributes}
                {...merge(containerStyle, element.containerAttributes)}
            >
                {children}
                <Hr {...element.attributes} />
            </Container>
        );
    },
    PreviewElement: ({ node, attributes }) => {
        const containerStyle = {
            style: {
                maxWidth: '100%',
            },
        };
        return (
            <Container {...merge({}, node.containerAttributes, containerStyle)}>
                <Hr {...attributes} />
            </Container>
        );
    },
};

export default divider;
